import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Get_server_time, Get_test } from "../../gql/queries";
import { Bookmark_QB, Report_Submit, Result_Submit } from "../../gql/mutation";
import { getTestTime, transform } from "../../utils";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { firebaseData } from "../../firebase";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import { decrypt } from "../../utils/crypto";
import ConnectionError from "../common/NoDataFound/ConnectionError";
const INITIAL_STATE = {
    contentType: "",
    userFeedBack: "",
    category: "",
    contentId: ''
};

export default function TestAttempt() {
    let { id } = useParams()
    const naviagte = useNavigate()
    const [testResume, testshowResume] = useState(false);
    const showTestResume = () => testshowResume(true);
    const testHide = () => testshowResume(false);
    const [config, setConfig] = useState();
    const [remoteLoading, setRemoteLoading] = useState(true);
    const [course, setCourse] = useState(JSON.parse(decrypt(localStorage.getItem('profileDetails'))));
    let localAttemtedQuestions = JSON.parse(localStorage.getItem(id)) ? JSON.parse(localStorage.getItem(id)) : [];   // all attempted questions
    let time = JSON.parse(localStorage.getItem('time')) > 0 ? JSON.parse(localStorage.getItem('time')) : 0;
    let localstartTime = JSON.parse(localStorage.getItem('start')) ? JSON.parse(localStorage.getItem('start')) : ''; // get start time from localstorage
    // let endtime = new Date() //get submit time
    // var duration = moment.duration((moment(endtime)).diff(moment(localstartTime)));
    // let totalduration = duration.minutes();
    const REACT_APP_ImageURL= 'https://dbmi-data.s3.ap-south-1.amazonaws.com/'
    let location = useLocation();
    const [index, setIndex] = useState(parseInt(location.state)?parseInt(location.state):0);
    const [counter, setCounter] = useState(parseInt(time));
    const [questionAttempt, setQuestionAttempt] = useState(localAttemtedQuestions);
    const [showList, setShowList] = useState('list');
    const [isGuessedadd, setIsGuessed] = useState(false);
    const [isReviewedadd, setIsReviewed] = useState(false);
    let [isState, setIsState] = useState(false);
    const [dataById, setDataById] = useState({});
    const [getDetails, Details] = useState(INITIAL_STATE);
    const [qbResume, qbShow] = useState(false);
    const [infoShow, setInfo] = useState(false);
    const [testQuitResume, testQuitshowResume] = useState(false);
    const [imgPopup, setImgPopup] = useState(false);
    const [showImg, setShowImg] = useState();
    const showQuitTestResume = () => testQuitshowResume(true);
    const testQuitHide = () => testQuitshowResume(false);
    const showPopupImg = (d) => {
        setImgPopup(true);
        setShowImg(d);
    };
    const imgHide = () => setImgPopup(false);
    const infoDetailShow = () => setInfo(true);
    const infoDetailhide = () => setInfo(false);
    const qbDetailShow = () => qbShow(true);
    const [isTestActive, setIsTestActive] = useState(false);
    const qbHide = () => qbShow(false);
    const query2 = useQuery(Get_server_time,{
          fetchPolicy:'network-only'
    })
    const [enable,setDisabled] = useState(true)
    const [showGrid, setShowGrid] = useState(false);
    const [submitShow, setSubmitShow] = useState();
    const showSubmit = () => setSubmitShow(true);
    const submitHide = () => setSubmitShow(false);

    const toggleView = () => setShowGrid(true);
    const closeMobileQuesPalatte = () => setShowGrid(false);
    const getResumeTestTime = (server, start,duration) => {
        const startdateTime = new Date(start);
        const serverdateTime = new Date(server);
        const timeDifferenceInMilliseconds = Math.abs(serverdateTime - startdateTime);
        const totalduration = (timeDifferenceInMilliseconds / 1000);
        let resumeTime = ((parseInt(duration) - (totalduration/60)))
        resumeTime= resumeTime*60
        resumeTime=(parseInt(duration)*60)-resumeTime
        return resumeTime
    }
    useEffect(() => {
        window.history.pushState(null, null, window.location.href);
        window.onpopstate = function () {
            qbDetailShow()
        window.history.pushState(null, null, window.location.href);

        };
    }, []);
    useEffect(() => {
        window.addEventListener("beforeunload", function (e) {
            var confirmationMessage = "\o/";
            (e || window.event).returnValue = confirmationMessage;     //Gecko + IE
            return confirmationMessage;                                //Webkit, Safari, Chrome etc.
        });
    }, []);
   
    useEffect( () => {
        //  query2.refetch()
        const timer = schedule()
        return () => {
            // console.log(counter,"counter")
            if (counter == 1) {
                showQuitTestResume()
                // resultSubmit({ variables: {resultInput:{ qbId: query1.data.test._id, resultType: "Test", startTime:localstartTime,endTime:query2.data && query2.data.serverTime,duration:totalduration,questions:newquestionAttempt,questionInterval:0.0,category:query1.data.test.category,isCompleted:true,subjectId: query1.data.test.subject, topicId: query1.data.test.subjectDetail.topicId, courseName: course.preparingFor }}})
                // naviagte(`/testlayer/testperformance/${query1.data.test._id}`, { replace: true });
            }
            clearInterval(timer)
        };
    }, [counter])

    const schedule = () => {
        const time = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
        return time
    }

    const [report] = useMutation(Report_Submit)
    const [resultSubmit] = useMutation(Result_Submit);
    const [getBookmark] = useMutation(Bookmark_QB, {
        refetchQueries: [
            {
                query: Get_test,
                variables: {
                    "_id": id,
                },
            }, // DocumentNode object parsed with gql
            'test' // Query name,

        ],
    });
    const query1 = useQuery(Get_test, {
        variables: {
            "_id": id,
        },
    });
    useEffect(() => {
            const getConfigData = async () => {
                try {
                    const remoteData = await firebaseData('report_config'); // Replace 'your_config_key' with the actual key for the configuration value you want
                    setConfig(JSON.parse(remoteData));
                    setRemoteLoading(false);
                } catch (error) {
                    console.error('Error fetching remote data:', error);
                    setRemoteLoading(false);
                }
            };
    
            if (typeof window !== 'undefined') {
                getConfigData();
            }
    }, []);

    if (query1.loading) return (<><Loader /></>)
    if (query1.error) {
        if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            //   history.push('/login');
            authorizationCheck(naviagte)
        } 
        else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR') ) {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <SomethingWentWrong pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        else {
            return (<>
                <div className="main_wrapper">
                          <div className="col-lg-12">
                              <ConnectionError pathName={location.pathname}/>
                          </div>
                          </div>
                  </>)
        }
        console.log(query1.error)
    }

    const pre = () => {
        if (index > 0) {
            let preIndex = index - 1
            setIndex(preIndex);
            // setView(true)
        }
        if(questionAttempt[index-1]==null){
            setIsGuessed(false)
            setIsReviewed(false)
        }
    }
    const next = (index) => {
        if (index < query1.data.test.questions.length - 1) {
            let nextIndex = index + 1
            setIndex(nextIndex);
        }
        setIsGuessed(false)
        setIsReviewed(false)

    }
    const listView = (e) => {
        setShowList("list")
    }
    const gridView = (e) => {
        setShowList("grid")
    }
    // const MatchIds = (questionId) => {
    //     console.log(questionAttempt[index],"questionAttempt");
    //     let matchingIndexNum =  questionAttempt?.findIndex((obj) => obj.questionId == questionId);
    //     return matchingIndexNum;
    // }
    const selectedAnswer = (answer, questionId, userAnswer, optionIndex, reviewed, guessed,isAttempt) => {
        let key
        if(Array.isArray(questionAttempt)){
             key = questionAttempt.findIndex((obj) => {
                if (obj && obj.questionId !== undefined) {
                    return obj.questionId.toString() === questionId.toString();
                }
                return false;
            });
        }
    if(questionAttempt==null || questionAttempt==undefined || questionAttempt[index]==null || questionAttempt[index]==undefined){
        const data = {
            "questionId": questionId,
            "answer": answer,
            "userAnswer": userAnswer,
            "isReview": reviewed,
            "isGuessed": guessed,
            "isAttempt": isAttempt,
            "optionIndex": optionIndex
        }
        questionAttempt[index] = data       
    }
    else {
        if(key==-1){
            const data = {
                "questionId": questionId,
                "answer": answer,
                "userAnswer": userAnswer,
                "isReview": reviewed,
                "isGuessed": guessed,
                "isAttempt": isAttempt,
                "optionIndex": optionIndex
            }
            questionAttempt[index] = data
        }
        else if (key!=-1){
            if(optionIndex!==questionAttempt[index].optionIndex || reviewed!==questionAttempt[index].isReview || guessed!==questionAttempt[index].isGuessed)
            {
                const data = {
                    "questionId": questionId,
                    "answer": answer,
                    "userAnswer": userAnswer,
                    "isReview": reviewed,
                    "isGuessed": guessed,
                    "isAttempt": isAttempt,
                    "optionIndex": optionIndex
                }
                questionAttempt[index] = data
            }
            else{
                if(questionAttempt[index]?.isGuessed==true|| questionAttempt[index]?.isReview==true){
                    const data = {
                        "questionId": questionId,
                        "answer": answer,
                        "userAnswer": undefined,
                        "isReview": reviewed,
                        "isGuessed": guessed,
                        "isAttempt": false,
                        "optionIndex": null
                    }
                    questionAttempt[index] = data
                }
                else if(questionAttempt[index]?.isGuessed==false || questionAttempt[index]?.isReview==false){
                    const data = {
                        "questionId": questionId,
                        "answer": answer,
                        "userAnswer": undefined,
                        "isReview": reviewed,
                        "isGuessed": guessed,
                        "isAttempt": false,
                        "optionIndex": null
                    }
                    questionAttempt[index] = data
                   
                }
            }
    }
    else{
         questionAttempt.splice(key,1)
    }
}
        setQuestionAttempt(questionAttempt)
        localStorage.setItem(id, JSON.stringify(questionAttempt));
    }
    const review = (e) => {
        setIsReviewed(e.target.checked)
        selectedAnswer(query1.data.test.questions[index].answer[0], query1.data.test.questions[index]._id, questionAttempt[index] ? questionAttempt[index]?.userAnswer : undefined, questionAttempt[index] ? questionAttempt[index]?.optionIndex : 0, e.target.checked, questionAttempt[index] ? questionAttempt[index]?.isGuessed : false,questionAttempt[index] ? questionAttempt[index]?.isAttempt:false)
    }
    const guessed = (e) => {
        setIsGuessed(e.target.checked)
        selectedAnswer(query1.data.test.questions[index].answer[0], query1.data.test.questions[index]._id, questionAttempt[index] ? questionAttempt[index]?.userAnswer : undefined, questionAttempt[index] ? questionAttempt[index]?.optionIndex : 0, questionAttempt[index] ? questionAttempt[index]?.isReview : false, e.target.checked,questionAttempt[index] ? questionAttempt[index]?.isAttempt:false)
    }
    let newquestionAttempt = []
    let data
    questionAttempt&& questionAttempt!= null&& questionAttempt != undefined && questionAttempt.map((obj1, i) => {
        if(obj1!==null){
            data = {
                userAnswer: obj1?.userAnswer!=undefined? obj1?.userAnswer:'',
                questionId: obj1?.questionId,
                isReview: obj1?.isReview,
                isGuessed: obj1?.isGuessed
            }
            newquestionAttempt.push(data)
        }
    })
   
    // const gotoPerformance = () => {
    //      query2.refetch()
    //     if(!query2.loading  && query2?.data?.serverTime){
    //     resultSubmit({ variables: { resultInput: { qbId: query1.data.test._id, resultType: "Test", startTime: query1.data?.test?.progress?.startTime, endTime: query2.data && query2?.data?.serverTime, duration: parseFloat((getResumeTestTime(query2.data && query2?.data?.serverTime,query1.data?.test?.progress?.startTime,query1.data?.test?.duration)).toFixed(1)), questions: newquestionAttempt, questionInterval: 0.0, category: query1.data.test.category, isCompleted: true, subjectId: query1.data.test.subject, topicId: query1.data.test.subjectDetail.topicId, courseName: course.preparingFor } } })
    //         naviagte(`/testlayer/testperformance/${query1.data.test._id}`);
    //     }
    // }
    const gotoPerformance = async () => {
        try {
          // Use await to ensure that query2.refetch() is completed before proceeding
          const response = await query2.refetch();
          
        //   console.log(response.data?.serverTime, "kkkkkkkkkk");
      
          if (response && response?.data) {
            const startTime = query1.data?.test?.progress?.startTime;
            const serverTime = response?.data?.serverTime;
      
            const resumeTestTime = getResumeTestTime(serverTime, startTime, query1.data?.test?.duration);
            const duration = parseFloat(resumeTestTime.toFixed(1));
      
            const resultInput = {
              qbId: query1.data?.test?._id,
              resultType: "Test",
              startTime: startTime,
              endTime: serverTime,
              duration: duration,
              questions: newquestionAttempt,
              questionInterval: 0.0,
              category: query1.data.test.category,
              isCompleted: true,
              subjectId: query1.data.test.subject,
              topicId: query1.data.test.subjectDetail.topicId,
              courseName: course.preparingFor,
            };
      
            // Now, call resultSubmit only after ensuring that query2.data is available
            resultSubmit({ variables: { resultInput } });
            naviagte(`/testlayer/testperformance/${query1.data.test._id}`);
          }
        } catch (error) {
          // Handle any errors that occur during the refetch or resultSubmit process
          console.error("Error:", error);
        }
      };
    // const gotoInstrucation = () => {
    //     query2.refetch()
    //     if(!query2.loading  && query2?.data?.serverTime){
    //     resultSubmit({ variables: { resultInput: { qbId: query1.data?.test?._id, resultType: "Test", startTime: query1.data?.test?.progress?.startTime, endTime: query2.data && query2?.data?.serverTime, duration: parseFloat((getResumeTestTime(query2.data && query2?.data?.serverTime,query1.data?.test?.progress?.startTime,query1.data?.test?.duration)).toFixed(1)), questions: newquestionAttempt, questionInterval: 0.0, category: query1.data.test.category, isCompleted: true, subjectId: query1.data.test.subject, topicId: query1.data.test.subjectDetail.topicId, courseName: course.preparingFor } } })
    //     naviagte(`/testlayer/testperformance/${id}`);
    //     }
    // }
    const gotoInstrucation = async () => {
        try {
          // Use await to ensure that query2.refetch() is completed before proceeding
          const response = await query2.refetch();
          
      
          if (response && response?.data) {
            const startTime = query1.data?.test?.progress?.startTime;
            const serverTime = response?.data?.serverTime;
      
            const resumeTestTime = getResumeTestTime(serverTime, startTime, query1.data?.test?.duration);
            const duration = parseFloat(resumeTestTime.toFixed(1));
      
            const resultInput = {
              qbId: query1.data?.test?._id,
              resultType: "Test",
              startTime: startTime,
              endTime: serverTime,
              duration: duration,
              questions: newquestionAttempt,
              questionInterval: 0.0,
              category: query1.data.test.category,
              isCompleted: true,
              subjectId: query1.data.test.subject,
              topicId: query1.data.test.subjectDetail.topicId,
              courseName: course.preparingFor,
            };
      
            // Now, call resultSubmit only after ensuring that query2.data is available
            resultSubmit({ variables: { resultInput } });
            naviagte(`/testlayer/testperformance/${id}`);
          }
        } catch (error) {
          // Handle any errors that occur during the refetch or resultSubmit process
          console.error("Error:", error);
        }
      };
    const totalresult = async () => {
        try {
          // Use await to ensure that query2.refetch() is completed before proceeding
          const response = await query2.refetch();
          
      
          if (response && response?.data) {
            const startTime = query1.data?.test?.progress?.startTime;
            const serverTime = response?.data?.serverTime;
      
            const resumeTestTime = getResumeTestTime(serverTime, startTime, query1.data?.test?.duration);
            const duration = parseFloat(resumeTestTime.toFixed(1));
      
            const resultInput = {
              qbId: query1.data?.test?._id,
              resultType: "Test",
              startTime: startTime,
              endTime: serverTime,
              duration: duration,
              questions: newquestionAttempt,
              questionInterval: 0.0,
              category: query1.data.test.category,
              isCompleted: true,
              subjectId: query1.data.test.subject,
              topicId: query1.data.test.subjectDetail.topicId,
              courseName: course.preparingFor,
            };
      
            // Now, call resultSubmit only after ensuring that query2.data is available
            resultSubmit({ variables: { resultInput } });
            localStorage.removeItem(id);
            naviagte(`/testlayer/testperformance/${query1.data.test._id}`);
          }
        } catch (error) {
          // Handle any errors that occur during the refetch or resultSubmit process
          console.error("Error:", error);
        }
      };

      const submitTest = async () => {
        try {
          // Use await to ensure that query2.refetch() is completed before proceeding
          const response = await query2.refetch();
          
      
          if (response && response?.data) {
            const startTime = query1.data?.test?.progress?.startTime;
            const serverTime = response?.data?.serverTime;
      
            const resumeTestTime = getResumeTestTime(serverTime, startTime, query1.data?.test?.duration);
            const duration = parseFloat(resumeTestTime.toFixed(1));
      
            const resultInput = {
              qbId: query1.data?.test?._id,
              resultType: "Test",
              startTime: startTime,
              endTime: serverTime,
              duration: duration,
              questions: newquestionAttempt,
              questionInterval: 0.0,
              category: query1.data.test.category,
              isCompleted: false,
              subjectId: query1.data.test.subject,
              topicId: query1.data.test.subjectDetail.topicId,
              courseName: course.preparingFor,
            };
      
            // Now, call resultSubmit only after ensuring that query2.data is available
            resultSubmit({ variables: { resultInput } });
            naviagte(`/testlayer/testinstruction/${id}`)
          }
        } catch (error) {
          // Handle any errors that occur during the refetch or resultSubmit process
          console.error("Error:", error);
        }
      };
    // const submitTest =  () => {
    //     query2.refetch()
    //     if(!query2.loading && query2?.data?.serverTime){
    //     resultSubmit({ variables: { resultInput: { qbId: query1.data?.test?._id, resultType: "Test", startTime: query1.data?.test?.progress?.startTime, endTime: query1.data?.test?.serverTime, duration: parseFloat((getResumeTestTime(query2.data && query2?.data?.serverTime,query1.data?.test?.progress?.startTime,query1.data?.test?.duration)).toFixed(1)), questions: newquestionAttempt, questionInterval: 0.0, category: query1.data.test.category, isCompleted: false, subjectId: query1.data.test.subject, topicId: query1.data.test.subjectDetail.topicId, courseName: course.preparingFor } } })
    //     naviagte(`/testlayer/testinstruction/${id}`)
    //     }
    //     // naviagte(-1)
    // }

    const handleInputChange = function (fieldValue, fieldName) {
        getDetails.contentType = "Test"
        Details({ ...getDetails, [fieldName]: fieldValue })
        if (!fieldValue) {
            setDisabled(true)
        } else {
            setDisabled(false)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        getDetails.contentId = query1.data && query1.data.test.questions[index]._id
        report({ variables: { addReportInput: getDetails } }).then(res => {
            if (res.data.addUserReport.userId) {
                Details(INITIAL_STATE)
                setInfo(false)
                toast.success('Report Successful Submitted')
            }
        }).catch(res => {
            const errors = res.graphQLErrors.map(err => err.message);
            console.log(errors)
        })
    }

    const questionImagePlaceholders = (htmlContent) => {
        const modifiedHtmlContent = htmlContent?.replace(/<img\s+src=Image\[\d+\]>/g, '');
        return modifiedHtmlContent;
    };

    const removeImagePlaceholders = (htmlContent) => {
        const modifiedHtmlContent = htmlContent?.replace(/<img\s+src=Image\[\d+\]>/g, '');
        return modifiedHtmlContent;
    };

    const questionoriginalHtml = query1.data && query1.data?.test?.questions[index]?.question?.questionText
    const questionmodifiedHtml = questionImagePlaceholders(questionoriginalHtml);

    const solutionoriginalHtml = query1.data && query1.data?.test?.questions[index]?.solution?.solutionText
    const solutionmodifiedHtml = removeImagePlaceholders(solutionoriginalHtml);

    return (
        <>
            <div className="main_wrapper">
                <div className="breadcrumbs">
                    <ul className="breadcrumb mobile_attempt_crumb">
                        <li className="breadcrumb-item"><a >Home</a></li>
                        <li className="breadcrumb-item"><a >Test</a></li>
                        <li className="breadcrumb-item"><a >Test Category</a></li>
                        <li className="breadcrumb-item active"><a>{query1.data ? query1.data.test.title : ""}</a></li>
                    </ul>
                </div>
                <section className="videoLayer_wrapper qbanks_wrapper testInstruction_wrapper testAttempt_wrapper section_side_padding qb_attempt_top_padding">
                    <div className='row'>
                        <div className="col-lg-8 col-md-7 col-sm-12">
                            <div className="topics_wrapper_main">
                                <div className="subjects_wrapper topic_header">
                                    <div className="topic_header_content d-flex align-items-center">
                                        <div className="topic_image_ttl d-flex align-items-baseline">
                                            {/* <Link to={`/testlayer/testinstruction/${id}`}> */}
                                            <figure className="back_arrow" onClick={qbDetailShow}>
                                                <img src={Icons.BackArrow} alt="Back Arrow" className="img-fluid" />
                                            </figure>
                                            {/* </Link> */}
                                            <figure className="subject_inner_img">
                                                <img src={Images.Qbmark} alt="Subject Image" className="img-fluid" />
                                                <span className="text_qb">Test</span>
                                            </figure>
                                            <div className="subject_ttl_detail qbanks_ttl_details">
                                                <h5>{query1.data ? query1.data.test.title : ""}</h5>
                                                <div className="help_wrapper d-flex align-items-center">
                                                    <p><img src={Icons.HelpCircle} alt="Help" className="img-fluid" /><span className="ttl_questions">{query1.data ? query1.data.test.questions.length : 0} Questions</span></p>
                                                    <p className="clock_timer"><img src={Icons.Clock} alt="Help" className="img-fluid" /><span className="ttl_questions">{`${getTestTime(query1.data && query1.data.test)}`}</span></p>
                                                </div>
                                                <div className="expire_test">
                                                    <p>Expires: <span>{moment(query1.data.test.endTest).format("MMM DD hh:mm:ss A")}</span></p>
                                                </div>
                                                <div className="bookmarks_share">
                                                    {
                                                        query1.data && query1.data.test.progress == null &&
                                                        <span onClick={() => getBookmark({ variables: { resultId: query1.data.test.progress ? query1.data.test.progress._id : "", qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: 'NEET PG Program', "status": true } })}>
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid" /> Bookmark Test
                                                        </span>
                                                    }
                                                    {
                                                        query1.data && query1.data.test.progress != null && query1.data.test.progress.isBookMarked !== true &&
                                                        <span onClick={() => getBookmark({ variables: { resultId: query1.data.test.progress ? query1.data.test.progress._id : "", qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: 'NEET PG Program', "status": true } })}>
                                                            <img src={Icons.Bookmark} alt="" className="img-fluid" /> Bookmark Test
                                                        </span>
                                                    }
                                                    {
                                                        query1.data && query1.data.test.progress != null && query1.data.test.progress.isBookMarked === true &&
                                                        <span onClick={() => getBookmark({ variables: { resultId: query1.data.test.progress ? query1.data.test.progress._id : "", qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: 'NEET PG Program', "status": false } })}>
                                                            <img src={Icons.unBookmark} alt="" className="img-fluid" /> Bookmark Test
                                                        </span>
                                                    }
                                                    {/* <span>
                                                        <img src={Icons.ShareBlue} alt="" className="img-fluid" /> Share Test
                                                    </span> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="recommended_video_wrapper qbanks_timer">
                                    <div className="countdown_timer">
                                        <div className="clock_timer text-center">
                                            <img src={Icons.Timer} alt="" className="img-fluid" />
                                            <span>{transform(counter)}</span>
                                        </div>
                                        <div className="progress">
                                            <div className="progress-bar" style={{ width: `${(100 * counter) / (time * 60)}%` }}></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="recommended_video_wrapper instructions_wrapper qb_attempt_details">
                                    <div className="instruction_header d-flex align-items-center">
                                        <div className="attempt_ttl">
                                            <h6>Question {index + 1}<span> out of {query1.data ? query1.data.test.questions.length : 0}</span></h6>
                                        </div>
                                        <div className="ttl_options">
                                            <span onClick={infoDetailShow}>
                                                <img src={Icons.Info} alt="share" className="img-fluid" />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="instructions_details">
                                        <div className="questions_ttl">
                                            <h6 dangerouslySetInnerHTML={{ __html: questionmodifiedHtml }}></h6>
                                            <div className="ans_img_wrapper">
                                            {
                                            query1.data.test && query1.data.test.questions[index].question.questionImage[0]&&
                                            <img src={query1.data.test.questions[index].question.questionImage[0].includes('/') ?query1.data.test.questions[index].question.questionImage[0]: REACT_APP_ImageURL+query1.data.test.questions[index].question.questionImage[0]} alt="" className="img-fluid" />
                                            }
                                            {
                                            query1.data.test && query1.data.test.questions[index].question.questionImage[0]&&
                                            <figcaption className="img_fullscreen" onClick={()=>showPopupImg(query1.data.test.questions[index].question.questionImage[0].includes('/') ? query1.data.test.questions[index].question.questionImage[0]: REACT_APP_ImageURL+query1.data.test.questions[index].question.questionImage[0])}>
                                                <img src={Icons.Maximize} alt="" className="img-fluid" />
                                            </figcaption>
                                            }
                                                {/* <img src={(query1.data.test && query1.data.test.questions[index]) ? query1.data.test.questions[index].question.questionImage[0] : Images.AnsImg} alt="" className="img-fluid" />
                                                {
                                                    ((query1.data.test && query1.data.test.questions[index]) && query1.data.test.questions[index].question.questionImage[0]) &&
                                                    <figcaption className="img_fullscreen" onClick={()=>showPopupImg(query1.data.test.questions[index].question.questionImage[0])}>
                                                        <img src={Icons.Maximize} alt="" className="img-fluid" />
                                                    </figcaption>
                                                } */}
                                            </div>
                                        </div>

                                        <ul type="none" className="instruction_list">
                                            {
                                                query1.data.test && query1.data.test.questions[index] && query1.data.test.questions[index].options && query1.data.test.questions[index].options.map((d, i) => (
                                                    <li className={d._id == (questionAttempt[index] && questionAttempt[index].userAnswer) ? 'testCorrect' : ''} onClick={() => query1.refetch()}>
                                                        <div className="ins_list_content">
                                                            <div className="ques_attempt_body d-flex align-items-center" onClick={() => selectedAnswer(query1.data.test.questions[index].answer[0], query1.data.test.questions[index]._id, d._id, i, questionAttempt[index] ? questionAttempt[index].isReview : isReviewedadd, questionAttempt[index] ? questionAttempt[index].isGuessed : isGuessedadd,true)}>
                                                                <div className="inst_counts">
                                                                    <span>{String.fromCharCode(i + 65)}</span>
                                                                </div>
                                                                <div className="ins_texts">
                                                                    <p>{d.optionText}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>

                                                ))
                                            }
                                            {/* <li>
                                            <div className="ins_list_content">
                                                <div className="ques_attempt_body d-flex align-items-center ">
                                                    <div className="inst_counts">
                                                        <span>C</span>
                                                    </div>
                                                    <div className="ins_texts">
                                                        <p>Lesion to spinal root of accessory nerve</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="ins_list_content">
                                                <div className="ques_attempt_body d-flex align-items-center">
                                                    <div className="inst_counts">
                                                        <span>D</span>
                                                    </div>
                                                    <div className="ins_texts">
                                                        <p>Lesion to spinal root of accessory nerve</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </li> */}
                                        </ul>
                                    </div>
                                </div>
                                <div className="select_timer_wrapper">
                                    <div className="review_btn d-flex align-items-center">
                                        {
                                            // questionAttempt!=undefined&& questionAttempt[index] !== null && 
                                            <>
                                                <div className="rev_btn1">
                                                    <input type="checkbox" id="checkbox_1" name="checkboxName" checked={questionAttempt[index] && questionAttempt[index].isReview} onChange={(e) => review(e)} class="form-control" hidden="hidden" />
                                                    <label for="checkbox_1" className="btn btn_theme" ><img src={Icons.TickTest} alt="Tick" className="img-fluid" /> Review Later</label>
                                                </div>
                                                {
                                                    questionAttempt[index] && questionAttempt[index]?.isAttempt === true &&
                                                    <div className="rev_btn1 rev_btn2">
                                                        <input type="checkbox" id="checkbox_2" name="checkboxName" checked={questionAttempt[index] && questionAttempt[index].isGuessed} onChange={(e) => guessed(e)} class="form-control" hidden="hidden" />
                                                        <label for="checkbox_2" className="btn btn_theme"><img src={Icons.TickTest} alt="Tick" className="img-fluid" /> Guessed Answer</label>
                                                    </div>
                                                }
                                            </>
                                        }
                                        {/* {
                                            questionAttempt[index] === null || questionAttempt[index] === undefined && questionAttempt[index]==='' &&
                                            <>
                                                <div className="rev_btn1">
                                                    <input type="checkbox" id="checkbox_1" name="checkboxName" checked={isReviewedadd} onChange={(e) => review(e)} class="form-control" hidden="hidden" />
                                                    <label for="checkbox_1" className="btn btn_theme" ><img src={Icons.TickTest} alt="Tick" className="img-fluid" /> Review Laters</label>
                                                </div>
                                                {
                                                    questionAttempt[index] && questionAttempt[index]?.isAttempt === true &&
                                                    <div className="rev_btn1 rev_btn2">
                                                        <input type="checkbox" id="checkbox_2" name="checkboxName" checked={isGuessedadd} onChange={(e) => guessed(e)} class="form-control" hidden="hidden" />
                                                        <label for="checkbox_2" className="btn btn_theme"><img src={Icons.TickTest} alt="Tick" className="img-fluid" /> Guessed Answer</label>
                                                    </div>
                                                }
                                            </>
                                        } */}
                                        {/* <button type="button" onClick={(e) => review()}  className="btn btn_theme"><img src={Icons.TickTest} alt="Tick" className="img-fluid" /> Review Later</button>
                                    <button type="button" onClick={(e) => guessed()}  className="btn btn_theme"><img src={Icons.TickTest} alt="Tick" className="img-fluid"/> Guessed Answer</button> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-5 col-sm-12">
                            <div className="videos_wrapper">
                                <div className="recommended_video_wrapper hide_timer">
                                    <div className="countdown_timer">
                                        <div className="clock_timer text-center">
                                            <img src={Icons.Timer} alt="" className="img-fluid" />
                                            <span>{transform(counter)}</span>
                                        </div>
                                        <div className="progress">
                                            <div className="progress-bar" style={{ width: `${(100 * (counter)) / (parseInt(time))}%` }}></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="recommended_video_wrapper hide_web_toggle_view">
                                    <div className="all_questions_wrapper">
                                        <div className="all_question_ttl">
                                            <h6>All Questions</h6>
                                            <p>{query1.data && query1.data.test.title}</p>
                                        </div>
                                        <div className="questions_indicators d-flex align-items-center">
                                            <div className="questions_options_indicators d-flex">
                                                <p className="skipped"><span></span>Answered</p>
                                                <p className="unanswered"><span></span>Unanswered</p>
                                            </div>
                                            <div className="choose_views">
                                                <span className={`list_view ${showList === 'list' ? 'colored' : ''}`} onClick={(e) => listView(e)}>
                                                    <img src={Icons.ListView} alt="" className="img-fluid" />
                                                </span>
                                                <span className={`grid_view  ${showList !== 'list' ? 'colored' : ''}`} onClick={(e) => gridView(e)}>
                                                    <img src={Icons.GridView} alt="" className="img-fluid" />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="all_questions_listings">
                                            {
                                                showList == 'list' &&
                                                <ul type="none" className="questions_list_child">
                                                    {
                                                        query1.data && query1.data.test.questions.map((d, i) => (
                                                            // questionAttempt[i]&&questionAttempt[i].isAttempt==true &&
                                                            <li onClick={(e) => next(i - 1)}>
                                                                <div className="question_body d-flex align-items-center">
                                                                    <div className="question_body_details d-flex align-items-center">
                                                                        <figure className={`user_img ${((questionAttempt[i] && questionAttempt[i].userAnswer) != undefined ? 'skipped' : 'unanswered')}`}>
                                                                            <span className="bookarks_qb">Q{i + 1}</span>
                                                                        </figure>
                                                                        <div className="continue_qbanks_wrapper">
                                                                            <h6>{d.question.questionText}</h6>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ))
                                                    }
                                                    {/* {
                                                    query1.data && query1.data.test.questions.map((d, i) => (
                                                        questionAttempt[i] == undefined &&
                                                        <li onClick={(e) => next(i - 1)}>
                                                            <div className="question_body d-flex align-items-center">
                                                                <div className="question_body_details d-flex align-items-center">
                                                                    <figure className="user_img unanswered">
                                                                        <span className="bookarks_qb">Q{i + 1}</span>
                                                                    </figure>
                                                                    <div className="continue_qbanks_wrapper">
                                                                        <h6>{d.question.questionText}</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))
                                                } */}
                                                    {/* <li>
                                                <div className="question_body d-flex align-items-center">
                                                    <div className="question_body_details d-flex align-items-center">
                                                        <figure className="user_img">
                                                            <span className="bookarks_qb">Q3</span>
                                                        </figure>
                                                        <div className="continue_qbanks_wrapper">
                                                            <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                        </div>
                                                        <div className="rightArrow_icn">
                                                            <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="question_body d-flex align-items-center">
                                                        <div className="question_body_details d-flex align-items-center">
                                                            <figure className="user_img">
                                                                <span className="bookarks_qb">Q7</span>
                                                            </figure>
                                                            <div className="continue_qbanks_wrapper">
                                                                <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                            </div>
                                                        </div>
                                                        <div className="rightArrow_icn">
                                                            <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </li> */}
                                                </ul>
                                            }
                                            {

                                                showList == 'grid' &&
                                                <ul type="none" className="questions_list_child grid_view d-flex flex-wrap">
                                                    {
                                                        query1.data && query1.data.test.questions.map((d, i) => (
                                                            // questionAttempt[i]&&questionAttempt[i].isAttempt==true &&
                                                            <li onClick={(e) => next(i - 1)}><span className={((questionAttempt[i] && questionAttempt[i].userAnswer) != undefined ? 'skipped' : 'unanswered')}>Q{i + 1}</span></li>
                                                        ))
                                                    }
                                                    {/* {
                                                    query1.data && query1.data.test.questions.map((d, i) => (
                                                        questionAttempt[i] == undefined &&
                                                        <li onClick={(e) => next(i - 1)}><span className='unanswered'>Q{i + 1}</span></li>
                                                    )
                                                    )
                                                } */}
                                                </ul>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="nexts_prevs_buttons">
                                    {/* <button type="button" className="btn btn_theme btn_prev">Previous</button>
                            <button type="button" className="btn btn_theme btn_next">Next</button> */}
                                    {
                                        // isView == true &&
                                        <button type="button" className="btn btn_theme btn_prev" onClick={(e) => pre(index)}>Previous</button>
                                    }
                                    {
                                        index < query1.data.test.questions.length - 1 &&

                                        <button type="button" className="btn btn_theme btn_next" onClick={(e) => next(index)}>Next</button>
                                    }
                                    {
                                       index == query1.data.test.questions.length - 1 &&

                                        <button type="button" className="btn btn_theme btn_next" disabled onClick={(e) => next(index)}>Next</button>
                                    }
                                    {/* {
                                        index == query1.data.test.questions.length - 1 &&
                                        <button type="button" className="btn btn_theme btn_next" onClick={() => totalresult()}>Submit</button>
                                    } */}
                                    {/* <button type="button" className="btn btn_theme btn_next">Submit</button> */}
                                </div>
                            </div>
                            <div className="submit_attempt_btn d-none d-md-block d-lg-block">
                                {
                                    <button type="button" className="btn btn_theme" onClick={showSubmit}>Submit Test</button>
                                }
                            </div>
                        </div>
                    </div>
                    <span className="toggle_view" onClick={toggleView}>
                        <img src={Icons.ListGridToggle} alt="" className="img-fluid"/>
                    </span>
                    {
                        showGrid!==false &&
                        <div className="recommended_video_wrapper mobile_toggled_view">
                            <div className="all_questions_wrapper">
                                <div className="mobile_view_ques_number d-flex justify-content-between">
                                    <div className="all_question_ttl">
                                        <h6>All Questions</h6>
                                        <p>{query1.data && query1.data.test.title}</p>
                                    </div>
                                    <span className="cross_img" onClick={closeMobileQuesPalatte}>
                                        <img src={Icons.ModalCross} alt="" className="img-fluid"/>
                                    </span>
                                </div>
                                <div className="questions_indicators d-flex align-items-center">
                                    <div className="questions_options_indicators d-flex">
                                        <p className="skipped"><span></span>Answered</p>
                                        <p className="unanswered"><span></span>Unanswered</p>
                                    </div>
                                    <div className="choose_views">
                                        <span className={`list_view ${showList === 'list' ? 'colored' : ''}`} onClick={(e) => listView(e)}>
                                            <img src={Icons.ListView} alt="" className="img-fluid" />
                                        </span>
                                        <span className={`grid_view  ${showList !== 'list' ? 'colored' : ''}`} onClick={(e) => gridView(e)}>
                                            <img src={Icons.GridView} alt="" className="img-fluid" />
                                        </span>
                                    </div>
                                </div>
                                <div className="all_questions_listings">
                                    {
                                        showList == 'list' &&
                                        <ul type="none" className="questions_list_child">
                                            {
                                                query1.data && query1.data.test.questions.map((d, i) => (
                                                    // questionAttempt[i]&&questionAttempt[i].isAttempt==true &&
                                                    <li onClick={(e) => next(i - 1)}>
                                                        <div className="question_body d-flex align-items-center">
                                                            <div className="question_body_details d-flex align-items-center">
                                                                <figure className={`user_img ${((questionAttempt[i] && questionAttempt[i].userAnswer) != undefined ? 'skipped' : 'unanswered')}`}>
                                                                    <span className="bookarks_qb">Q{i + 1}</span>
                                                                </figure>
                                                                <div className="continue_qbanks_wrapper">
                                                                    <h6>{d.question.questionText}</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))
                                            }
                                            {/* {
                                            query1.data && query1.data.test.questions.map((d, i) => (
                                                questionAttempt[i] == undefined &&
                                                <li onClick={(e) => next(i - 1)}>
                                                    <div className="question_body d-flex align-items-center">
                                                        <div className="question_body_details d-flex align-items-center">
                                                            <figure className="user_img unanswered">
                                                                <span className="bookarks_qb">Q{i + 1}</span>
                                                            </figure>
                                                            <div className="continue_qbanks_wrapper">
                                                                <h6>{d.question.questionText}</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            ))
                                        } */}
                                            {/* <li>
                                        <div className="question_body d-flex align-items-center">
                                            <div className="question_body_details d-flex align-items-center">
                                                <figure className="user_img">
                                                    <span className="bookarks_qb">Q3</span>
                                                </figure>
                                                <div className="continue_qbanks_wrapper">
                                                    <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                </div>
                                                <div className="rightArrow_icn">
                                                    <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="question_body d-flex align-items-center">
                                                <div className="question_body_details d-flex align-items-center">
                                                    <figure className="user_img">
                                                        <span className="bookarks_qb">Q7</span>
                                                    </figure>
                                                    <div className="continue_qbanks_wrapper">
                                                        <h6>A 20 year old female presented with multiple lesions below eyes...</h6>
                                                    </div>
                                                </div>
                                                <div className="rightArrow_icn">
                                                    <img src={Icons.ChevRight} alt="Play" className="img-fluid" />
                                                </div>
                                            </div>
                                        </div>
                                    </li> */}
                                        </ul>
                                    }
                                    {

                                        showList == 'grid' &&
                                        <ul type="none" className="questions_list_child grid_view d-flex flex-wrap">
                                            {
                                                query1.data && query1.data.test.questions.map((d, i) => (
                                                    // questionAttempt[i]&&questionAttempt[i].isAttempt==true &&
                                                    <li onClick={(e) => next(i - 1)}><span className={((questionAttempt[i] && questionAttempt[i].userAnswer) != undefined ? 'skipped' : 'unanswered')}>Q{i + 1}</span></li>
                                                ))
                                            }
                                            {/* {
                                            query1.data && query1.data.test.questions.map((d, i) => (
                                                questionAttempt[i] == undefined &&
                                                <li onClick={(e) => next(i - 1)}><span className='unanswered'>Q{i + 1}</span></li>
                                            )
                                            )
                                        } */}
                                        </ul>
                                    }
                                </div>
                                <div className="submit_attempt_btn mb-0">
                                {
                                    <button type="button" className="btn btn_theme" onClick={showSubmit}>Submit Test</button>
                                }
                            </div>
                            </div>
                        </div>
                    }
                </section>
            </div>
            <ToastContainer />
            <Modal
                show={infoShow}
                onHide={infoDetailhide}
                backdrop="static"
                className="detail_modal report_modal"
                centered
            >
                <form action="" onSubmit={(e) => { handleSubmit(e) }}>
                    <Modal.Header>
                        <Modal.Title>
                            <h4>Report Issue</h4>
                            <span className="cross_icon">
                                <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={infoDetailhide} />
                            </span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="rating_modal_body">
                            <div className="form-group">
                                <label htmlFor="">Issue Type</label>
                                <select name="" id="" className="form-control" onChange={(e) => handleInputChange(e.target.value, 'category')} value={getDetails.category ?? ''}>
                                    <option value=''>Please Select</option>
                                    {
                                        config && config.test_question?.categories?.map((d, i) => (
                                            <option value={d.category_name}>{d.category_name}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Description</label>
                                <textarea name="" id="" rows="5" className="form-control" placeholder="Please add issue description here..." onChange={(e) => handleInputChange(e.target.value, 'userFeedBack')} value={getDetails.userFeedBack}></textarea>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="rating_submit">
                            <button type="button" className="btn btn_theme btn_border" onClick={infoDetailhide}>Cancel</button>
                            <button type="submit" disabled={enable} className="btn btn_theme" >Submit</button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal
                show={qbResume}
                onHide={qbHide}
                backdrop="static"
                className="detail_modal report_modal qbQuit_modal"
                centered
            >
                <Modal.Body>
                    <div className="rating_modal_body text-center">
                        <h5>Are you sure you want to quit this Test?</h5>
                        <p>You can anytime come back and continue from where you left.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="rating_submit">
                        <button type="button" className="btn btn_theme" onClick={qbHide}>Cancel</button>
                        <button type="button" className="btn btn_theme btn_theme_red" onClick={submitTest}>Yes, Quit</button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal
                show={testResume}
                onHide={testHide}
                backdrop="static"
                className="detail_modal report_modal testReumse"
                centered
            >
                <Modal.Body>
                    <div className="rating_modal_body text-center">
                        <h5>Your time is out!</h5>
                        <p>You cannot attempt this test now as you have run out of time. Click on view performance to check your score</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="rating_submit">
                        <button type="button" className="btn btn_theme btn_border" onClick={testHide}>Cancel</button>
                        <button type="button" className="btn btn_theme" onClick={gotoPerformance}>View Performance</button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal
                show={testQuitResume}
                onHide={gotoInstrucation}
                backdrop="static"
                className="detail_modal report_modal testReumse"
                centered
            >
                <Modal.Body>
                    <div className="rating_modal_body text-center">
                        <h5>Your time is out!</h5>
                        <p>You cannot attempt this test now as you have run out of time. Click on View Performance to check your score</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="rating_submit">
                        <button type="button" className="btn btn_theme btn_border" onClick={gotoInstrucation}>Cancel</button>
                        <button type="button" className="btn btn_theme" onClick={gotoInstrucation}>View Performance</button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal 
            show={imgPopup}
            onHide={imgHide}
            backdrop="static"
            className="detail_modal modelImgPopup"
            centered
            size="lg"
            >
            <Modal.Body>
                <div className="Img_wrapper">
                    <span className="cross_icon">
                        <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={imgHide}/>
                    </span>
                    <div className="img_popup">
                        <img src={showImg} alt="Popup Image" />
                    </div>
                </div>
            </Modal.Body>
            </Modal>
            <Modal
        show={submitShow}
        onHide={submitHide}
        backdrop="static"
        className="detail_modal report_modal device_reached"
        centered
    >
            <Modal.Body>
                <div className="account_option_wrapper">
                    <div className="cross_icon text-right">
                        <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={submitHide}/>
                    </div>
                    <div className="account_header text-center">
                        <h6>Are you sure you want to submit?</h6>
                        <p>Please make sure you have checked unattempted questions before you submit</p>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="rating_submit">
                    <button type="button" className="btn btn_theme btn_border" onClick={submitHide}>Cancel</button>
                    <button type="submit" className="btn btn_theme" onClick={() => totalresult()}>Yes, Submit</button>
                </div>
            </Modal.Footer>
        </Modal>
        </>
    )
}